import OrganizationsList from "../views/OrganizationsList.vue"
import OrganizationsCreate from "../views/OrganizationsCreate.vue"
import OrganizationsUpdate from "../views/OrganizationsUpdate.vue"
import OrganizationsDetail from "../views/OrganizationsDetail.vue"
import OrganizationSubscriptions from "../components/mockedApeiron/OrganizationSubscriptions.vue"

export default [
	{
		path: "/:tenantId/organizations",
		component: OrganizationsList,
		meta: { featureId: "organizations" },
		name: "OrganizationsList"
	},
	{
		path: "/:tenantId/organizations/create",
		component: OrganizationsCreate,
		meta: { featureId: "organizations" },
		name: "OrganizationsCreate"
	},
	{
		path: "/:tenantId/organizations/update/:id",
		component: OrganizationsUpdate,
		meta: { featureId: "organizations" },
		name: "OrganizationsUpdate",
		props: true
	},
	{
		path: "/:tenantId/organizations/detail/:id",
		component: OrganizationsDetail,
		meta: { featureId: "organizations" },
		name: "OrganizationsDetail",
		props: true
	},
	{
		path: "/:tenantId/organizations/detail/:id/subscriptions",
		component: OrganizationSubscriptions,
		meta: { featureId: "organizations" },
		name: "OrganizationSubscriptions",
		props: true
	}
]
